import { useQuery } from '@tanstack/react-query';

export interface PostalResult {
  zipcode: string;
  prefcode: string;
  address1: string;
  address2: string;
  address3: string;
  kana1: string;
  kana2: string;
  kana3: string;
}

export interface PostalApiResponse {
  message: string | null;
  results: PostalResult[] | null;
  status: number;
}

const fetchPostalData = async (postalCode: string): Promise<PostalResult | null> => {
  if (!postalCode) return null;

  const res = await fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${postalCode}`);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const data: PostalApiResponse = await res.json();

  if (data.status !== 200) {
    throw new Error(data.message || 'Failed to fetch postal data');
  }

  return data.results?.[0] || null;
};

export const usePostalCodeQuery = (postalCode: string) => {
  return useQuery<PostalResult | null, Error>({
    queryKey: ['postalCode', postalCode],
    queryFn: () => fetchPostalData(postalCode),
    enabled: false,
    retry: 1,
  });
};
